<div
  class="qr-wrapper"
  [style.width.px]="width"
  [style.height.px]="width"
  [innerHTML]="qrCodeSvg"
></div>
